export default "__VITE_ASSET__s5Xvb4Uw__"